// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-4efa211a]{line-height:28px}.contentList[data-v-4efa211a]{margin:10px 0}.mirror[data-v-4efa211a]{margin-right:10px;width:200px;border-radius:6px;cursor:pointer}.mirror .deleteButton[data-v-4efa211a]{height:0;overflow:hidden;position:relative;top:-5px;left:5px;text-align:right}.mirror[data-v-4efa211a]:hover{border-color:var(--el-color-primary)}.mirror:hover .deleteButton[data-v-4efa211a]{overflow:visible}", ""]);
// Exports
module.exports = exports;
